import contentLayerComponent from './index.vue'

const contentLayer = {
    install : (Vue) => {
        Vue.component('contentLayer', contentLayerComponent);
    }
}

export default contentLayer



// WEBPACK FOOTER //
// ./src/base/contentLayer/index.js